import { render, staticRenderFns } from "./VrstaSuorganizatoraEdit.vue?vue&type=template&id=7623a16c&scoped=true&"
import script from "./VrstaSuorganizatoraEdit.vue?vue&type=script&lang=js&"
export * from "./VrstaSuorganizatoraEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7623a16c",
  null
  
)

export default component.exports